<template>
  <router-link class="nav-mark" to="/">
    <div class="nav-wave">
      <div
        v-for="(bar, i) in navBars"
        :key="i"
        class="nav-bar"
        :style="{ height: bar.height, '--dur': bar.dur, '--delay': bar.delay }"
      ></div>
    </div>
    <div class="nav-wordmark">
      <span class="nav-prof-de">Prof DE</span>
      <span class="nav-beats">BEATS</span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'NavMark',
  data: function () {
    return {
      navBars: [
        { height: '6px', dur: '1.6s', delay: '0.0s' },
        { height: '14px', dur: '1.4s', delay: '0.1s' },
        { height: '20px', dur: '1.7s', delay: '0.2s' },
        { height: '24px', dur: '1.5s', delay: '0.3s' },
        { height: '20px', dur: '1.6s', delay: '0.2s' },
        { height: '14px', dur: '1.4s', delay: '0.1s' },
        { height: '6px', dur: '1.7s', delay: '0.0s' }
      ]
    }
  }
}
</script>

<style scoped>
.nav-mark {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  opacity: 0;
  animation: fadeIn 0.6s ease forwards 0.2s;
}

.nav-wave {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 24px;
}

.nav-bar {
  width: 2px;
  border-radius: 1px;
  background: linear-gradient(180deg, var(--gold-light), var(--gold-deep));
  animation: pulse var(--dur, 1.4s) ease-in-out infinite;
  animation-delay: var(--delay, 0s);
  transform-origin: center;
  opacity: 0.67;
}

@keyframes pulse {
  0%, 100% { transform: scaleY(1);   opacity: 0.6; }
  50%       { transform: scaleY(0.3); opacity: 0.27; }
}

.nav-wordmark {
  display: flex;
  flex-direction: column;
  line-height: 1;
  gap: 1px;
}

.nav-prof-de {
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-weight: 400;
  font-size: 11px;
  letter-spacing: 0.28em;
  background: linear-gradient(90deg, var(--gold-light), var(--gold-mid));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-transform: uppercase;
}

.nav-beats {
  font-family: 'Cinzel', serif;
  font-weight: 700;
  font-size: 17px;
  letter-spacing: 0.22em;
  background: linear-gradient(90deg, var(--gold-bright), var(--gold-mid));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-transform: uppercase;
}

@keyframes fadeIn { to { opacity: 1; } }
</style>
